{
  "recommendedAssetMix": "Recomendamos esta combinación de activos",
  "factorAffectingScore": "Factores que afectan su puntuación",
  "riskProfileIs": "Su perfil de riesgo es",
  "factorAffectingScoreDescription": "Los siguientes factores influyen en su perfil de riesgo.",
  "investmentKnowledge": "Conocimientos sobre inversiones",
  "investmentKnowledgeOptions": {
    "NONE": "Ninguno",
    "LIMITED": "Limitado",
    "SOME": "Algunos",
    "EXPERT": "Experto"
  },
  "timeHorizon": "Horizonte temporal",
  "goalTimeHorizon": {
    "VERY_SHORT_TERM": "A muy corto plazo",
    "SHORT_TERM": "A corto plazo",
    "MID_TERM": "A mediano plazo",
    "LONG_TERM": "A largo plazo",
    "VERY_LONG_TERM": "A muy largo plazo"
  },
  "riskProfileIsNotAvailable": "No disponible.",
  "previewRiskProfileName": "Moderado",
  "previewRiskProfileDescription": "Para clientes dispuestos a aceptar un nivel de riesgo moderado. Usted busca obtener altos rendimientos potenciales a mediano o largo plazo en condiciones normales de mercado."
}
